var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNuke(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190.612,
    height: 163,
    viewBox: "0 0 190.612 163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 190.612,
    height: 81.722,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 163,
    height: 163,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1923",
    "data-name": "Groupe 1923",
    transform: "translate(-274.138 -7688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1914",
    "data-name": "Groupe 1914",
    transform: "translate(274.138 7724.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1913",
    "data-name": "Groupe 1913",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_648",
    "data-name": "Trac\\xE9 648",
    d: "M25.066,61.694a.733.733,0,0,1-.583-.292L18.4,53.26a.727.727,0,0,1,0-.873l6.082-8.09a.728.728,0,0,1,1.31.437v2.133H41.929a.728.728,0,0,1,.64,1.075L36.884,58.4a.727.727,0,0,1-.639.381H25.794v2.183a.726.726,0,0,1-.5.69.69.69,0,0,1-.228.038m-5.173-8.867,4.445,5.95v-.72a.726.726,0,0,1,.728-.728H35.812l4.894-9.007H25.066a.726.726,0,0,1-.728-.728v-.681Z",
    transform: "translate(8.308 20.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_649",
    "data-name": "Trac\\xE9 649",
    d: "M6.932,56.915a.729.729,0,0,1-.621-.348l-6.2-10.16A.728.728,0,0,1,.1,45.663l5.237-9.045L3.447,35.523a.728.728,0,0,1,.281-1.353l10.091-1.183a.733.733,0,0,1,.755.439l3.954,9.317a.728.728,0,0,1-1.035.914l-1.847-1.068L7.561,56.553a.723.723,0,0,1-.62.362Zm-5.358-10.9,5.34,8.747,7.839-13.535a.726.726,0,0,1,.441-.338.733.733,0,0,1,.553.073l.589.342-2.89-6.81-7.376.866.624.361a.728.728,0,0,1,.265.994Z",
    transform: "translate(0 15.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_650",
    "data-name": "Trac\\xE9 650",
    d: "M33.739,41.494a.911.911,0,0,1-.108-.007l-10.013-1.48a.727.727,0,0,1-.24-1.359l1.874-1.019-7.7-14.179a.727.727,0,0,1,.639-1.075H30.092a.727.727,0,0,1,.639.381l4.991,9.183L37.64,30.9a.727.727,0,0,1,1.008.943L34.4,41.07a.726.726,0,0,1-.661.423m-7.753-2.609,7.319,1.081,3.105-6.744-.633.345a.746.746,0,0,1-.553.058.722.722,0,0,1-.434-.352L29.659,23.83H19.41l7.468,13.743a.725.725,0,0,1-.292.985Z",
    transform: "translate(7.946 10.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_651",
    "data-name": "Trac\\xE9 651",
    d: "M20.059,58.606H11.872a4.546,4.546,0,0,1-3.849-2.152L3.993,49.9a.728.728,0,0,1,1.24-.762l4.031,6.56a3.044,3.044,0,0,0,2.609,1.458h7.459V47.121H7.683a.728.728,0,0,1,0-1.455H20.059a.728.728,0,0,1,.728.728V57.879a.728.728,0,0,1-.728.728",
    transform: "translate(1.768 20.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_652",
    "data-name": "Trac\\xE9 652",
    d: "M33.574,52.6a.728.728,0,0,1-.637-.377L26.869,41.2a.726.726,0,0,1,.271-.979l9.468-5.515a.726.726,0,0,1,1,.262l4.72,8.082a3.082,3.082,0,0,1-.017,3.139l-3.632,6.052a.728.728,0,1,1-1.248-.748l3.632-6.052a1.629,1.629,0,0,0,.01-1.659l-4.355-7.453-8.227,4.792,5.724,10.4a.727.727,0,0,1-.636,1.078",
    transform: "translate(12.187 15.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_653",
    "data-name": "Trac\\xE9 653",
    d: "M18.258,38.9a.738.738,0,0,1-.358-.093L8.133,33.292a.733.733,0,0,1-.349-.469.722.722,0,0,1,.106-.573l4.726-6.995a6.537,6.537,0,0,1,5.423-2.88H22.6a.728.728,0,0,1,0,1.455H18.04a5.083,5.083,0,0,0-4.218,2.241l-4.285,6.34L18.022,37.2l6.469-9.9a.727.727,0,1,1,1.218.8L18.868,38.571a.724.724,0,0,1-.61.33",
    transform: "translate(3.534 10.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_654",
    "data-name": "Trac\\xE9 654",
    d: "M111.152,71.018H32.669V69.563h77.352A123.442,123.442,0,0,1,100.2,25.987H78.052a116.711,116.711,0,0,1-3.258,23.779c-.4,1.643-.808,3.211-1.225,4.7l-.677,2.408-.72-2.394a138.511,138.511,0,0,1-6-35.94H40.126a132.093,132.093,0,0,1-2.135,19.95l-1.43-.262A130.542,130.542,0,0,0,38.69,17.795l.016-.712H67.594l.016.712a135.554,135.554,0,0,0,5.231,33.782q.273-1.052.537-2.151a114.841,114.841,0,0,0,3.238-24.182l.016-.712h24.99l.016.712a120.6,120.6,0,0,0,10.168,44.729l.506,1.046Z",
    transform: "translate(14.868 7.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_655",
    "data-name": "Trac\\xE9 655",
    d: "M57.948,58.044l-1.324-.6a104.453,104.453,0,0,0,5.85-18.125l1.419.322a105.783,105.783,0,0,1-5.944,18.406",
    transform: "translate(25.77 17.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 27.541,
    height: 1.455,
    transform: "translate(53.998 32.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    width: 24.161,
    height: 1.455,
    transform: "translate(92.081 40.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_656",
    "data-name": "Trac\\xE9 656",
    d: "M48.113,35.653a4.923,4.923,0,1,1,4.923-4.923,4.929,4.929,0,0,1-4.923,4.923m0-8.39a3.468,3.468,0,1,0,3.468,3.468,3.471,3.471,0,0,0-3.468-3.468",
    transform: "translate(19.656 11.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_657",
    "data-name": "Trac\\xE9 657",
    d: "M73.124,40.889a4.923,4.923,0,1,1,4.923-4.923,4.929,4.929,0,0,1-4.923,4.923m0-8.39a3.468,3.468,0,1,0,3.468,3.468A3.471,3.471,0,0,0,73.124,32.5",
    transform: "translate(31.039 14.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_658",
    "data-name": "Trac\\xE9 658",
    d: "M42.048,25.6l-1.455-.031c.045-2.22-1.992-3.8-3.63-5.062a6.622,6.622,0,0,1-2.222-2.254,3.339,3.339,0,0,1,.07-2.612,4.774,4.774,0,0,1,2.573-2.5,6.643,6.643,0,0,1,2.737-.464c-.042-.06-.084-.119-.125-.18A5.171,5.171,0,0,1,39.24,8.65a6.866,6.866,0,0,1,4.716-4.831,13.49,13.49,0,0,1,6.595-.212A32.094,32.094,0,0,1,60.889,7.283a2.723,2.723,0,0,0,1.487.517c.665-.116.939-.947,1.28-2.2.09-.335.18-.662.282-.966C65.1,1.2,69.23-.229,72.556.354c3.031.537,5.595,2.314,7.869,4.025,1.924-3.3,6.145-4.687,9.594-4.323,3.795.4,7.063,2.424,9.588,4.32a7.471,7.471,0,0,1,12.977.084,6.059,6.059,0,0,1,.7,4.389,4.427,4.427,0,0,1-3.181,3.268,7.026,7.026,0,0,1-1.529.134,3.969,3.969,0,0,0-1.567.218c-.773.359-1.142,1.241-1.57,2.261a12.05,12.05,0,0,1-.738,1.55c-1.876,3.121-5.988,3.546-8.94,2.952a36.516,36.516,0,0,1-4.685-1.381,38.615,38.615,0,0,0-4.09-1.244c-4.923-1.1-14.525-.994-19.506,2.757A7.5,7.5,0,0,0,64.309,25.1l-1.452-.084A8.892,8.892,0,0,1,66.6,18.2c5.348-4.028,15.514-4.178,20.7-3.015a39.57,39.57,0,0,1,4.246,1.289,35.468,35.468,0,0,0,4.5,1.33c2.688.538,6.015.039,7.407-2.277a10.735,10.735,0,0,0,.645-1.359,5.126,5.126,0,0,1,2.3-3.021,5.173,5.173,0,0,1,2.159-.354,5.994,5.994,0,0,0,1.222-.1,3,3,0,0,0,2.1-2.207,4.6,4.6,0,0,0-.554-3.319,6.019,6.019,0,0,0-10.785.6l-.371.872-.745-.582C96.958,4.147,93.655,1.9,89.866,1.5c-3.179-.327-7.129,1.026-8.514,4.268l-.365.857-.744-.563C77.927,4.308,75.3,2.317,72.3,1.786c-2.661-.474-6.087.662-6.983,3.313-.095.278-.176.579-.259.883-.359,1.323-.808,2.97-2.433,3.251a3.772,3.772,0,0,1-2.447-.68,30.652,30.652,0,0,0-9.871-3.513,12.186,12.186,0,0,0-5.893.159,5.485,5.485,0,0,0-3.751,3.757A3.683,3.683,0,0,0,41.21,11.7a2.794,2.794,0,0,0,1.768,1.262L42.732,14.4a9.506,9.506,0,0,0-4.809.1,3.318,3.318,0,0,0-1.774,1.713,1.942,1.942,0,0,0-.061,1.493,6.755,6.755,0,0,0,1.765,1.652c1.8,1.388,4.255,3.29,4.2,6.244",
    transform: "translate(15.705 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 1.456,
    height: 3.685,
    transform: "translate(95.958 6.071) rotate(-53.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_659",
    "data-name": "Trac\\xE9 659",
    d: "M50.983,8.688l-.148-1.446c3.668-.374,4.636-2.047,4.675-2.119L56.8,5.8c-.051.1-1.3,2.434-5.816,2.893",
    transform: "translate(23.135 2.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_660",
    "data-name": "Trac\\xE9 660",
    d: "M78.968,30.761l-1.441-.208c.252-1.743,1.072-4.87,3.751-6.231a8.1,8.1,0,0,1,4.984-.509c.477.07.955.159,1.43.247a16.756,16.756,0,0,0,3.057.381,4.4,4.4,0,0,0,3.564-1.433,3.621,3.621,0,0,0,.455-3.235,6.378,6.378,0,0,0-2.11-2.936l-1.253-1.043,1.612-.237a11.615,11.615,0,0,0,4.051-1.1,3.463,3.463,0,0,0,1.916-2.929,3.988,3.988,0,0,0-1.425-2.558,9.714,9.714,0,0,0-4.728-2.491l.292-1.426a11.182,11.182,0,0,1,5.445,2.869,5.356,5.356,0,0,1,1.868,3.534,4.857,4.857,0,0,1-2.654,4.268,10,10,0,0,1-3.114,1.039,7.141,7.141,0,0,1,1.489,2.578,5.1,5.1,0,0,1-.693,4.55,5.825,5.825,0,0,1-4.716,2,18.036,18.036,0,0,1-3.325-.406c-.458-.086-.918-.17-1.378-.24a6.739,6.739,0,0,0-4.112.371c-2.171,1.1-2.8,3.959-2.968,5.139",
    transform: "translate(35.283 2.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_661",
    "data-name": "Trac\\xE9 661",
    d: "M67.392,28.151l-1.411-.358a7.46,7.46,0,0,0,.324-2.005,1.989,1.989,0,0,0-.592-1.473,3.564,3.564,0,0,0-.581-.368A3.185,3.185,0,0,1,63.9,22.942a2.429,2.429,0,0,1-.159-2.181,4.887,4.887,0,0,1,1.035-1.531,1.58,1.58,0,0,0,.317-.428,1.167,1.167,0,0,0-.29-.179,6.047,6.047,0,0,0-1.385-.348,4.669,4.669,0,0,1-2.545-1A3.639,3.639,0,0,1,59.827,14.8a5.707,5.707,0,0,1,1.24-3.888l1.132.912a4.246,4.246,0,0,0-.92,2.888,2.292,2.292,0,0,0,.581,1.494,3.459,3.459,0,0,0,1.8.633,7.159,7.159,0,0,1,1.727.451,1.752,1.752,0,0,1,1.145,1.337,2.01,2.01,0,0,1-.69,1.585A3.593,3.593,0,0,0,65.1,21.28a1.011,1.011,0,0,0,.019.867,2.032,2.032,0,0,0,.722.528,4.916,4.916,0,0,1,.819.533,3.426,3.426,0,0,1,1.1,2.536,8.731,8.731,0,0,1-.368,2.407",
    transform: "translate(27.223 4.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_662",
    "data-name": "Trac\\xE9 662",
    d: "M115.357,28.383a11.062,11.062,0,0,1-1.375-.087c-6.356-.784-9.743-8.736-9.885-9.076l-.178-.423.306-.34c.266-.3,6.59-7.249,14.237-4.914a7.764,7.764,0,0,1,4.939,3.8,9.12,9.12,0,0,1,.365,6.493l-.076.153a10.226,10.226,0,0,1-8.333,4.393m-9.72-9.294c.774,1.606,3.786,7.178,8.524,7.763a8.834,8.834,0,0,0,8.255-3.572A7.68,7.68,0,0,0,122.1,18a6.373,6.373,0,0,0-4.061-3.062c-5.847-1.783-11.068,2.842-12.4,4.154M123.078,23.6h0Z",
    transform: "translate(47.295 5.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_663",
    "data-name": "Trac\\xE9 663",
    d: "M126.819,26.968a9.1,9.1,0,0,1-4.274-1.058l-.137-.1a8.021,8.021,0,0,1-2.333-5.23,6.83,6.83,0,0,1,2.33-4.976c5.023-4.886,12.735-2.021,13.061-1.895l.428.163.038.458c.025.32.578,7.869-4.067,11.038a8.814,8.814,0,0,1-5.046,1.6M123.356,24.7a7.525,7.525,0,0,0,7.69-.53c3.341-2.28,3.491-7.625,3.454-9.246-1.63-.5-7.36-1.895-11.081,1.726a5.453,5.453,0,0,0-1.889,3.914,6.545,6.545,0,0,0,1.825,4.135",
    transform: "translate(54.647 5.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_664",
    "data-name": "Trac\\xE9 664",
    d: "M127.795,32.588l-.194-.7c-.122-.445-3.165-10.922-17.4-13.065l-.72-.108.217-1.438.719.108c15.2,2.287,18.553,14,18.585,14.12l.191.7Z",
    transform: "translate(49.827 7.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_665",
    "data-name": "Trac\\xE9 665",
    d: "M120.978,27.136l-1.265-.719.359-.633c1.768-3.105,7.46-8.268,7.7-8.488l.54-.487.976,1.08-.54.487c-.057.052-5.762,5.225-7.414,8.128Z",
    transform: "translate(54.483 7.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_666",
    "data-name": "Trac\\xE9 666",
    d: "M114.511,71.237a27.413,27.413,0,0,1-4.012-54.53l.72-.1.212,1.439-.72.108a25.933,25.933,0,1,0,28.174,16.74l-.249-.682,1.365-.5.252.684a27.433,27.433,0,0,1-25.742,36.848",
    transform: "translate(39.641 7.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_667",
    "data-name": "Trac\\xE9 667",
    d: "M121.077,56.487l-1.825-4.354a8.11,8.11,0,0,0-6.442-4.91,7.5,7.5,0,0,0-4.268.966c-3.331,2.181-5.989,1.481-8.335.867-1.679-.442-3.13-.825-4.722-.208l-2.427.939-.525-1.358,2.429-.94c2.028-.784,3.852-.306,5.615.159,2.253.592,4.378,1.148,7.168-.675A8.889,8.889,0,0,1,113,45.78a9.57,9.57,0,0,1,7.6,5.79l1.825,4.354Z",
    transform: "translate(42.113 20.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_668",
    "data-name": "Trac\\xE9 668",
    d: "M89.092,47.608l-1.173-.863,5.1-6.934a2.122,2.122,0,0,0,.263-2.544,3.537,3.537,0,0,1,.071-3.844l.793-1.176a2.078,2.078,0,0,0-.473-2.824l-3.779-2.081.7-1.273,3.863,2.136a3.546,3.546,0,0,1,.891,4.857l-.793,1.176a2.073,2.073,0,0,0-.042,2.26,3.554,3.554,0,0,1-.371,4.229Z",
    transform: "translate(40.013 11.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_669",
    "data-name": "Trac\\xE9 669",
    d: "M110.537,51.964a2.576,2.576,0,0,1-1.091-.24l-.166-.106-4.7-4a6.608,6.608,0,0,1-3.225-8.585,3.179,3.179,0,0,0-.336-3.078l-1.256-1.758a4.633,4.633,0,0,1,.371-5.822l1.16-1.251a8.386,8.386,0,0,1,7.757-2.555,4.615,4.615,0,0,1,3.462,6.164,3.159,3.159,0,0,0,.741,3.366,7.888,7.888,0,0,1,1.4,9.327,3.945,3.945,0,0,0-.373,2.957,4.4,4.4,0,0,1-2.455,5.305,3.323,3.323,0,0,1-1.285.279m-.4-1.526a1.515,1.515,0,0,0,1.123-.095,2.939,2.939,0,0,0,1.628-3.532,5.4,5.4,0,0,1,.482-4.082,6.425,6.425,0,0,0-1.142-7.6,4.616,4.616,0,0,1-1.08-4.917A3.16,3.16,0,0,0,108.777,26a6.95,6.95,0,0,0-6.418,2.114l-1.161,1.25a3.173,3.173,0,0,0-.253,3.987l1.256,1.759a4.642,4.642,0,0,1,.49,4.493,5.158,5.158,0,0,0,2.589,6.737l.166.106Zm-8.313-22.822h0Z",
    transform: "translate(45.012 11.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_670",
    "data-name": "Trac\\xE9 670",
    d: "M118.386,55.164,116.9,49.041a3.075,3.075,0,0,1,1.621-3.492,1.637,1.637,0,0,0,.869-1.793l-.2-.987a7.171,7.171,0,0,1,2.513-7.044,3.091,3.091,0,0,1,4.735,1.068l1.443,3.024-1.313.629-1.443-3.024a1.635,1.635,0,0,0-2.506-.567,5.724,5.724,0,0,0-2.005,5.621l.2.987a3.093,3.093,0,0,1-1.644,3.387,1.626,1.626,0,0,0-.857,1.848l1.487,6.125Z",
    transform: "translate(53.161 15.944)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1921",
    "data-name": "Groupe 1921",
    transform: "translate(285 7688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1921-2",
    "data-name": "Groupe 1921",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_710",
    "data-name": "Trac\\xE9 710",
    d: "M148.824,123.7a79.414,79.414,0,0,1-134.649,0H11.8a81.46,81.46,0,0,0,139.4,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_711",
    "data-name": "Trac\\xE9 711",
    d: "M11.574,43.7a79.474,79.474,0,0,1,139.852,0h2.246a81.444,81.444,0,0,0-144.345,0Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuke);
export default __webpack_public_path__ + "static/media/Nuke.2eada2c31b0b7a8aa62643513f208e88.svg";
export { ForwardRef as ReactComponent };